"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _PhysicalCardListPane = _interopRequireDefault(require("./PhysicalCardListPane.vue"));
var _PhysicalCardDetailPane = _interopRequireDefault(require("./PhysicalCardDetailPane.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PhysicalCard',
  components: {
    PhysicalCardListPane: _PhysicalCardListPane.default,
    PhysicalCardDetailPane: _PhysicalCardDetailPane.default
  },
  data: function data() {
    return {
      activeName: 'physical_card_table',
      currentCrId: null,
      currentCardTypeName: '',
      imgAccessDomain: process.env.VUE_APP_COMMENT_IMAGE_URL
    };
  },
  methods: {
    handleClick: function handleClick(tab) {
      this.activeName = tab.name;
    },
    handleToCardList: function handleToCardList(crId, cardTypeName) {
      this.currentCrId = crId;
      this.currentCardTypeName = cardTypeName;
      this.activeName = 'physical_card_detail';
    }
  }
};